import React, { useEffect, useRef, useState } from 'react';

import './recargas.css';
import { DualRing } from 'react-spinners-css';
import { IMaskInput } from 'react-imask';
import { styled } from '@mui/material/styles';
import Slider from '@mui/material/Slider';

import { useServices } from '../../hooks/useServices';
import PWAPrompt from "react-ios-pwa-prompt";
import Alert from '@mui/material/Alert';
import Backdrop from '@mui/material/Backdrop';
import { Monto } from './Monto';
import { Elije } from './Elije';
import { Helmet } from 'react-helmet';

import { useHistory } from 'react-router-dom';
import { Beneficios } from './Beneficios';
import { Legales } from './Legales';


const PrettoSlider = styled(Slider)({
  color: '#cc1f1f',
  height: 18,
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-thumb': {
    height: 50,
    width: 50,
    backgroundColor: '#fff',
    border: '4px solid currentColor',
    '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
      boxShadow: 'inherit',
    },
    '&:before': {
      display: 'none',
    },
  },
  '& .MuiSlider-valueLabel': {
    lineHeight: 1.2,
    fontSize: 16,
    background: 'unset',
    padding: 0,
    width: 45,
    height: 45,
    borderRadius: '50% 50% 50% 0',
    backgroundColor: '#fb6f6f',
    transformOrigin: 'bottom left',
    transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
    '&:before': { display: 'none' },
    '&.MuiSlider-valueLabelOpen': {
      transform: 'translate(50%, -100%) rotate(-45deg) scale(1)',
    },
    '& > *': {
      transform: 'rotate(45deg)',
    },
  },
});

export const Recargas = () => {

  const ref = useRef();
  const inputRef = useRef();
  const refTexto = useRef('incorrecto');
  const canvas = useRef();
  const esSegundo = useRef(false);
  let ctx = null;

  const [valida, setValida] = useState(false);
  const [validaNum, setValidaNum] = useState(false);
  const [btnValida, setBtnValida] = useState(false);
  const [btnValida2, setBtnValida2] = useState(false);
  const [sliderC, setSliderC] = useState(false);
  const [open, setOpen] = useState(false);
  const [dn, setDn] = useState('');
  const [montos, setMontos] = useState([]);
  const [numeroRandom, setNumeroRandom] = useState(30);
  const [eligePago, setEligePago] = useState(false);
  const [tiembla, setTiembla] = useState(false);
  const [pagar, setPagar] = useState(false);
  const [loader, setLoader] = useState(false);
  const [oferta, setOferta] = useState(true);

  const [respuesta, setRespuesta] = useState({});


  const history = useHistory();

  const { validateDn, getPago, getCODI, validateSuperMontos } = useServices();

  const miUrl = window.location.hostname;
  const port = window.location.port;
  const protocol = window.location.protocol;



  const [lic1, setLic1] = useState({
    "dn": null,
    "financialAccount": "12345",
    "transactionExtId": "",
    "channelId": 21,//canal ATT 18 - canal Unefon 19 - canal web 21
    "chargeAmount": null,
    "ipAddress": "",
    "paymentDetail": [
      {
        "detailId": 0,//Es un consecutivo de la lista para identificar el pago
        "paymentTypeId": 2,//tipo de pago el 2 es Tiempo Aire
        "unitPrice": null,
        "quantity": 1,//Cantidad de Items adquiridos por tipo de pago
        "amount": null,//Monto del item seleccionado con IVA
        "percentageTax": 16,//Se refiere al porcentaje del IVA a utilizar
        "saleOrder": null,
        "bluePackage": null,
        "compraAddOnVO": null,
        "order": null,
        "purchaseOfferRequest": null,
        "package": null
      }],
    "urlReturn": `${protocol}//${miUrl}:${port}/recibopago`,
    "customerId": null,//Identificador del cliente
    "token": ""
  });

  const montosPermitidos = [
    {
      "validity": "1",
      "value": "10"
    },
    {
      "validity": "2",
      "value": "20"
    },
    {
      "validity": "3",
      "value": "30"
    },
    {
      "validity": "7",
      "value": "50"
    },
    {
      "validity": "7",
      "value": "70"
    },
    {
      "validity": "14",
      "value": "100"
    },
    {
      "validity": "28",
      "value": "150"
    },
    {
      "validity": "30",
      "value": "200"
    },
    {
      "validity": "33",
      "value": "300"
    },
  ]

  const montosPermitidos3 = [
    {
      "validity": "7",
      "value": "10"
    },
    {
      "validity": "7",
      "value": "20"
    },
    {
      "validity": "30",
      "value": "50"
    },
    {
      "validity": "30",
      "value": "100"
    }
  ]


  let objetoRespuesta = {};

  const base = useRef();
  const verAmbiente = () => {
    switch (miUrl) {
      case 'tu.unefon.com.mx'://produccion
        base.current = 'https://tu.att.com.mx/recarga';
        break;
      case '127.0.0.1'://react
        base.current = 'https://tu-dev-att.mx.att.com/recarga';
        ////console.log('ambiente react');
        break;
      case 'localhost'://local
        base.current = 'https://tu-dev-att.mx.att.com/recarga';
        ////console.log('ambiente local');
        break;
      case 'https://tu-dev-unefon.mx.att.com/'://ambiente E
        base.current = 'https://tu-dev-att.mx.att.com/recarga';
        ////console.log('ambiente E');
        break;
      case 'https://tu-qa-unefon.mx.att.com/'://ambiente A
        base.current = 'https://tu-qa.mx.att.com/recarga';
        // //console.log('ambiente A');
        break;
      default:
        base.current = 'https://tu-qa.mx.att.com/recarga';
        ////console.log('ambiente default');
        break;
    }
  }


  async function verBotonPago() {
    const { value } = await getPago(3);//1 es PAGO ATT 3 es PAGO UNEFON
    setLoader(true);
    if (value === "0") {//0 es activado 1 es desactivado
      setPagar(true);
    }
  }
  async function verOferta() {
    const { value } = await getCODI(14);//aqui trae si la oferta/beneficios son visibles
    console.log('valor: ', value);
    if (value === "1") {//0 es activado 1 es desactivado
      setOferta(false);
    }
  }


  const handleClick = () => {
    history.push("/locator");
  }

  const mostrarBoton = () => {
    setBtnValida(true);
    setBtnValida2(true);
  }

  const ocultarBoton = () => {
    setBtnValida2(false);
    setTimeout(() => {
      setBtnValida(false);
    }, 900);
  }

  const regresaRecarga = () => {
    window.location.replace('/recarga');

  }

  const handleClose = () => {
    setOpen(false);
  };


  const handleInput = (value) => {
    let dnInput = value;
    let mystring;
    if (value.includes("-")) {
      mystring = dnInput.split('-').join('');
    } else {
      mystring = dnInput;
    }

    ocultarBoton();
    if (mystring.length == 10) {
      setDn(mystring);
      setSliderC(true);
      setRandomNum();
    } else {
      setDn(mystring);
      setSliderC(false);
      ocultarBoton();
    }



  }

  let contador = 0;
  const handleChange = (event, value) => {
    contador++;
    if (contador == 3) {
      setRandomNum();
      setTiembla(true);
      setTimeout(() => {
        contador = 0;
        setTiembla(false);
      }, 500);

    } else {
      if (value == numeroRandom) {
        mostrarBoton();

      } else {
        ocultarBoton();
      }
    }

  };



  const randomIntFromInterval = (min, max) => { // min and max included 
    return Math.floor(Math.random() * (max - min + 1) + min)
  }

  const setRandomNum = () => {
    let number2 = randomIntFromInterval(5, 30);
    setNumeroRandom(number2);
    draw(number2);
  }


  const getMonto = (monto) => {
    setLic1({ ...lic1, chargeAmount: monto })
    setEligePago(true);
  }



  const servicioDN = async () => {
    const { value } = await getPago(13);
    if (value) {
      const validacion = await validateDn(dn, value);
      if (Object.keys(objetoRespuesta).length === 0) {
        objetoRespuesta = validacion;
        setRespuesta(validacion);
        valida2();
      }
    } else {
      setValidaNum(false);
      refTexto.current = 'Ocurrio un error al validar el número, intentalo más tarde';

      setOpen(true);
    }

  }

  const servicioDNSuper = async () => {
    esSegundo.current = false;
    const reqMontos = {
      "channel": "040",
      "offerID": "",
      "phone": dn
    }
    const resmontos = await validateSuperMontos(reqMontos);
    if (resmontos) {
      //console.log('respuesta montos: ', resmontos);
      if (resmontos.status) {
        setValidaNum(false);
        refTexto.current = 'Ocurrio un error al validar el número, intentalo más tarde';

        setOpen(true);
      } else {
        if (resmontos.amountsVO?.[0]?.amountVO?.[0]?.description?.includes("Segundo")) {
          esSegundo.current = true;

          setLic1({ ...lic1, dn: dn })
          setMontos(montosPermitidos3);

          setValida(true);
          setValidaNum(false);
          validarDN();
        } else {

          validarDN();


        }

      }



    } else {
      setValidaNum(false);
      refTexto.current = 'Ocurrio un error al validar el número, intentalo más tarde';

      setOpen(true);
    }


  }


  const validarDN = () => {
    servicioDN();
  }

  const validarDNSuper = () => {
    servicioDNSuper()
  }

  const valida2 = () => {
    if (Object.keys(objetoRespuesta).length !== 0) {
      console.log('respuesta dentro de valida2: ', objetoRespuesta);
      if (objetoRespuesta.status) {
        setValidaNum(false);
        refTexto.current = `Error en el servicio de validación. ${objetoRespuesta.status}`
        setOpen(true);

      } else {
        if (objetoRespuesta.code != "00") {
          setValidaNum(false);
          refTexto.current = ` Introduzca un número apto para realizar recarga`
          setOpen(true);

        } else {
          switch (objetoRespuesta.topUp.operator) {
            case "UNEFON":
              setLic1({ ...lic1, dn: dn })
              setMontos(esSegundo.current ? montosPermitidos3 : montosPermitidos); // correcto
              setValidaNum(false);
              setValida(true);

              break;
            case "AT&T":
              window.location.replace(base.current);
              break;
            default:
              setValidaNum(false);
              break;
          }


        }

      }

    } else {
      setValidaNum(false);
      refTexto.current = 'Ocurrio un error al validar el número, intentalo más tarde';

      setOpen(true);
    }

  }



  const validarClick = () => {
    setValidaNum(true);

    setTimeout(() => {
      validarDNSuper();
    }, 2000);



  }

  const draw = (number) => {
    const canvasEle = canvas.current;
    if (!canvasEle) return;

    const ctx = canvasEle.getContext("2d");
    if (!ctx) return;

    ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);

    // Añadir algo de "ruido" al canvas (líneas) para complicar el OCR
    for (let i = 0; i < 6; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * 35, Math.random() * 35);
      ctx.lineTo(Math.random() * 35, Math.random() * 35);
      ctx.strokeStyle = '#b0b0b0ff';
      ctx.stroke();
    }

    ctx.font = "20px Arial";
    ctx.fillStyle = '#000';

    // Rotar ligeramente el texto
    ctx.save();
    ctx.translate(17, 17);
    ctx.rotate((Math.random() - 0.5) * 0.4);
    ctx.fillText(number.toString(), -12, 8);
    ctx.restore();
  }




  useEffect(() => {
    verAmbiente();
    verBotonPago();
    verOferta();

  }, []);




  return (
    <div>
      <Helmet>
        <title>Recargas Unefon</title>
      </Helmet>


      {!loader
        ? <div className="spinner"><DualRing color="#0568ae" /></div>
        : !pagar
          ?
          <div className='contenedorPromociones'>
            <div className="logoUnefonR "></div>
            <div className='titRecarga '>Recargas</div>
            <div className='tit2'> Sistema de recargas en mantenimiento. </div>
            <div className='imagenMantenimiento'></div>
            <div onClick={handleClick} className="btnpagotiendaM1 animate__animated animate__flipInX" >
              Localiza puntos de recarga
              <div className="icoTienda"></div>
            </div>
            <div className='tit3'> Recuerda que puedes realizar tu recarga en tu tienda favorita o en < a href="https://miunefonweb.unefon.com.mx/" target='_blank' alt="Mi ATT">MiATT.</a></div>
          </div>
          :
          <>
            <div className="logoUnefonR "></div>
            <div className='contenedorGral'>

              <div className="contenedorRecargas">
                <Backdrop
                  sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                  open={open}
                  onClick={handleClose}
                >
                  <Alert severity="warning" onClose={() => { }}>{refTexto.current}</Alert>

                </Backdrop>

                <PWAPrompt
                  copyTitle="Recargas ATT "
                  copyBody="Esta página tiene funcionalidad de APP. Agregala a tu pantalla principal para usarla en modo completo y facilmente "
                  promptOnVisit={1}
                  timesToShow={3}
                  copyShareButtonLabel="1) Presiona el boton 'Compartir'"
                  copyAddHomeButtonLabel="2) Presiona 'Agregar a inicio'"
                  copyClosePrompt="Cancelar"
                  permanentlyHideOnDismiss={false}
                />


                <div className="titulo1">Recarga Unefon</div>
                <div className='text1'>Beneficios en todas tus recargas en línea</div>
                <div className='ibanner'>
                  <img src="https://www.unefon.com.mx/assets/img/recargas/recarga_desk.jpg" alt="Banner publicidad doble de gb desde 10 pesos" />
                </div>
                <div className='ibannerMov'>
                  <img src="https://www.unefon.com.mx/assets/img/recargas/recarga_mob.jpg" alt="Banner publicidad doble de gb desde 10 pesos" />
                </div>

                {
                  !valida ?
                    <div className='contienecel '>
                      <div className='tituloInput'>
                        Ingresa el número Unefon a recargar
                      </div>

                      <IMaskInput className='inputNumero'
                        inputMode="numeric"
                        pattern="[0-9]*"
                        mask={"000-0000-000"}
                        placeholder='Número celular a 10 dígitos'
                        radix=""
                        value={dn}
                        unmask={true} // true|false|'typed'
                        ref={ref}
                        inputRef={inputRef}  // access to nested input
                        // DO NOT USE onChange TO HANDLE CHANGES!
                        // USE onAccept INSTEAD
                        onAccept={
                          // depending on prop above first argument is
                          // `value` if `unmask=false`,
                          // `unmaskedValue` if `unmask=true`,
                          // `typedValue` if `unmask='typed'`
                          (value, mask) => handleInput(value)
                        }
                      //placeholder='Escribe tu número aquí'
                      />

                      {
                        sliderC &&
                        <>
                          <div className='tituloInput'>
                            Ayúdanos a validar que eres una persona
                          </div>
                          <div className='contenedorSlider '>

                            {/* <div className='tiSlider'>Desliza el slide hasta el número: <span style={{ color: '#000', fontSize:'20px', fontWeight:'bolder' }}>{numeroRandom}</span></div> */}
                            <div className={'tiSlider animate__animated  ' + (tiembla ? 'animate__heartBeat' : 'animate__pulse')}>Desliza el slide hasta el número:  <canvas ref={canvas} width="45" height="45"></canvas></div>

                            <PrettoSlider defaultValue={1} aria-label="Default" max={30} valueLabelDisplay="auto" onChangeCommitted={handleChange} />


                          </div>
                        </>

                      }
                      {
                        btnValida &&

                        <div className={'button button--anthe    ' + (btnValida2 ? 'animate__bounceInLeft' : 'animate__bounceOutLeft')} onClick={validarClick}><span>Siguiente</span></div>

                      }

                    </div>

                    : <>
                      <Monto dn={dn} montos={montos} getMonto={getMonto} />
                      {
                        eligePago &&

                        <Elije lic={lic1} />

                      }
                      <div onClick={regresaRecarga} className='button button--telesto'><span>Quiero recargar otro número</span></div>

                    </>


                }

                {
                  validaNum &&


                  <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={!valida}

                  >
                    <DualRing color="#fff" />


                  </Backdrop>

                }





              </div>
              {oferta &&
                <Beneficios />
              }
            </div>

            <Legales />

          </>
      }








    </div>


  )
}
